var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChallengesCompleted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Challenges",
    clipPath: "url(#clip0_3520_8863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_4146",
    opacity: 0.87,
    d: "M16.5 0C25.34 0 32.5 7.16 32.5 16C32.5 24.84 25.34 32 16.5 32C7.66 32 0.5 24.84 0.5 16C0.5 7.16 7.66 0 16.5 0Z",
    fill: "#E9D8FD"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.3098 27.3702C15.6298 27.3702 14.9498 27.3102 14.2798 27.1902C11.9698 26.7802 9.85984 25.6702 8.18984 24.0002C6.71984 22.5302 5.67984 20.6902 5.17984 18.6902C4.94984 17.7902 4.83984 16.8502 4.83984 15.9002C4.83984 9.57018 9.98984 4.43018 16.3098 4.43018C22.6298 4.43018 27.7798 9.58017 27.7798 15.9002C27.7798 18.9602 26.5898 21.8302 24.4298 24.0002C22.2598 26.1702 19.3798 27.3702 16.3098 27.3702Z",
    fill: "#FBD38D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.3099 4.87C22.3999 4.87 27.3499 9.81 27.3499 15.91C27.3499 18.95 26.1199 21.71 24.1299 23.7C22.1299 25.7 19.3699 26.94 16.3199 26.94C15.6499 26.94 14.9999 26.88 14.3599 26.77C12.0899 26.36 10.0599 25.27 8.49992 23.7C7.11992 22.31 6.09992 20.55 5.60992 18.59C5.38992 17.73 5.27992 16.83 5.27992 15.91C5.27992 9.81 10.2199 4.87 16.3199 4.87M16.3199 4C9.75992 4 4.41992 9.34 4.41992 15.91C4.41992 16.89 4.53992 17.87 4.77992 18.81C5.29992 20.89 6.37992 22.79 7.89992 24.32C9.62992 26.06 11.8199 27.2 14.2199 27.63C14.9099 27.75 15.6199 27.82 16.3299 27.82C19.5199 27.82 22.5099 26.58 24.7599 24.32C26.9999 22.07 28.2299 19.08 28.2299 15.91C28.2299 9.35 22.8899 4 16.3299 4H16.3199Z",
    fill: "#1A202C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M16.31 6.44012C22.14 6.44012 26.91 10.9601 27.32 16.6901C27.34 16.4301 27.35 16.1701 27.35 15.9101C27.35 9.81012 22.41 4.87012 16.31 4.87012C10.21 4.87012 5.27002 9.81012 5.27002 15.9101C5.27002 16.1801 5.28002 16.4401 5.30002 16.7001C5.70002 10.9701 10.47 6.44012 16.31 6.44012Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M14.2499 9.47021H13.3799V14.2602H14.2499V9.47021Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M16.0498 8.83008H13.8198V10.5101H16.0498V8.83008Z",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.4799 10.9499H13.3799V8.3999H16.4799V10.9499ZM14.2499 10.0799H15.6099V9.2599H14.2499V10.0799Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M18.1298 10.5099L18.7498 9.66992H16.0498V11.3499H18.7498L18.1298 10.5099Z",
    fill: "#F56565"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M19.5999 11.7902H15.6099V9.24023H19.5999L18.6699 10.5202L19.5999 11.8002V11.7902ZM16.4799 10.9202H17.8899L17.5899 10.5102L17.8899 10.1002H16.4799V10.9202Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M24.5603 16.7101H24.5203C23.7903 16.5601 23.2603 15.9001 23.2603 15.1401C23.2603 14.3801 23.7803 13.7801 24.4703 13.6101C24.7003 12.8501 25.4103 12.3101 26.2303 12.3101C27.0503 12.3101 27.7603 12.8501 27.9903 13.6101C28.6803 13.7801 29.2003 14.4001 29.2003 15.1401C29.2003 15.8801 28.6703 16.5601 27.9403 16.7101H27.9003H24.5703H24.5603Z",
    fill: "#EDF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M26.22 12.7401C26.95 12.7401 27.55 13.2901 27.62 14.0001C28.25 14.0001 28.75 14.5101 28.75 15.1401C28.75 15.6901 28.36 16.1801 27.83 16.2801H24.59C24.07 16.1801 23.67 15.6901 23.67 15.1401C23.67 14.5101 24.18 14.0001 24.8 14.0001C24.88 13.2901 25.48 12.7401 26.2 12.7401M26.2 11.8701C25.27 11.8701 24.45 12.4301 24.1 13.2501C23.34 13.5401 22.79 14.2701 22.79 15.1301C22.79 16.1001 23.47 16.9301 24.4 17.1201L24.48 17.1401H27.89L27.97 17.1201C28.91 16.9301 29.58 16.1001 29.58 15.1301C29.58 14.2701 29.03 13.5301 28.27 13.2501C27.92 12.4301 27.11 11.8701 26.17 11.8701H26.2Z",
    fill: "#1A202C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M24.8199 14.63C24.8999 13.92 25.4999 13.37 26.2199 13.37C26.9399 13.37 27.5499 13.92 27.6199 14.63C28.1399 14.63 28.5699 14.98 28.6999 15.45C28.7299 15.35 28.7499 15.24 28.7499 15.13C28.7499 14.5 28.2399 13.99 27.6199 13.99C27.5399 13.28 26.9399 12.73 26.2199 12.73C25.4999 12.73 24.8899 13.28 24.8199 13.99C24.1899 13.99 23.6899 14.5 23.6899 15.13C23.6899 15.24 23.7099 15.35 23.7399 15.45C23.8799 14.98 24.3099 14.63 24.8199 14.63Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M4.9598 14.1303H4.9198C4.2698 13.9903 3.7998 13.4103 3.7998 12.7403C3.7998 12.0703 4.2398 11.5603 4.8298 11.4003C5.0498 10.7503 5.6498 10.3003 6.3598 10.3003C7.0698 10.3003 7.6798 10.7503 7.8898 11.4003C8.4798 11.5603 8.9198 12.1003 8.9198 12.7403C8.9198 13.4103 8.4498 13.9903 7.7998 14.1203H7.7598H4.9598V14.1303Z",
    fill: "#EDF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M6.35988 10.7401C6.96988 10.7401 7.46988 11.2001 7.53988 11.7901C8.05988 11.7901 8.48988 12.2201 8.48988 12.7401C8.48988 13.2001 8.15988 13.6101 7.71988 13.6901H5.00988C4.56988 13.6001 4.23988 13.2001 4.23988 12.7401C4.23988 12.2201 4.65988 11.7901 5.18988 11.7901C5.25988 11.2001 5.75988 10.7401 6.36988 10.7401M6.36988 9.87012C5.54988 9.87012 4.83988 10.3501 4.50988 11.0601C3.84988 11.3301 3.37988 11.9901 3.37988 12.7401C3.37988 13.6201 3.99988 14.3801 4.83988 14.5401L4.91988 14.5601H7.79988L7.87988 14.5401C8.72988 14.3701 9.33988 13.6101 9.33988 12.7401C9.33988 11.9801 8.86988 11.3301 8.20988 11.0601C7.87988 10.3501 7.16988 9.87012 6.34988 9.87012H6.36988Z",
    fill: "#1A202C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M23.5097 8.97988H23.4697C23.0497 8.88988 22.7397 8.50988 22.7397 8.06988C22.7397 7.68988 22.9697 7.35988 23.3097 7.22988C23.4697 6.87988 23.8297 6.62988 24.2397 6.62988C24.6497 6.62988 25.0097 6.86988 25.1697 7.22988C25.4997 7.36988 25.7397 7.68988 25.7397 8.06988C25.7397 8.50988 25.4297 8.88988 25.0097 8.96988H24.9697H23.5197L23.5097 8.97988Z",
    fill: "#EDF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M24.2298 7.05994C24.5398 7.05994 24.7898 7.28994 24.8198 7.58994C25.0798 7.58994 25.2998 7.80994 25.2998 8.06994C25.2998 8.29994 25.1298 8.49994 24.9198 8.54994H23.5598C23.3398 8.50994 23.1798 8.29994 23.1798 8.06994C23.1798 7.80994 23.3898 7.58994 23.6598 7.58994C23.6898 7.28994 23.9398 7.05994 24.2498 7.05994M24.2498 6.18994C23.7198 6.18994 23.2598 6.46994 22.9998 6.88994C22.5898 7.11994 22.3198 7.55994 22.3198 8.05994C22.3198 8.70994 22.7798 9.25994 23.3998 9.38994L23.4798 9.40994H25.0098L25.0898 9.38994C25.7198 9.26994 26.1698 8.70994 26.1698 8.05994C26.1698 7.55994 25.8898 7.11994 25.4898 6.88994C25.2298 6.46994 24.7698 6.18994 24.2398 6.18994H24.2498Z",
    fill: "#1A202C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M5.18975 12.5502C5.25975 11.9602 5.75975 11.5002 6.36975 11.5002C6.97975 11.5002 7.47975 11.9602 7.54975 12.5502C7.93975 12.5502 8.26975 12.7902 8.41975 13.1202C8.46975 13.0002 8.49975 12.8702 8.49975 12.7402C8.49975 12.2202 8.07975 11.7902 7.54975 11.7902C7.47975 11.2002 6.97975 10.7402 6.36975 10.7402C5.75975 10.7402 5.25975 11.2002 5.18975 11.7902C4.66975 11.7902 4.23975 12.2202 4.23975 12.7402C4.23975 12.8702 4.26975 13.0002 4.31975 13.1202C4.46975 12.7802 4.79975 12.5502 5.18975 12.5502Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M9.20018 18.6103H9.16018C8.73018 18.5203 8.43018 18.1403 8.43018 17.7003C8.43018 17.3203 8.66018 16.9903 9.00018 16.8603C9.16018 16.5103 9.52018 16.2603 9.93018 16.2603C10.3402 16.2603 10.7002 16.5003 10.8602 16.8603C11.1902 17.0003 11.4302 17.3203 11.4302 17.7003C11.4302 18.1403 11.1202 18.5203 10.7002 18.6003H10.6602H9.21018L9.20018 18.6103Z",
    fill: "#EDF2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M9.93002 16.7001C10.24 16.7001 10.49 16.9301 10.52 17.2301C10.78 17.2301 11 17.4501 11 17.7101C11 17.9401 10.83 18.1401 10.62 18.1901H9.26002C9.04002 18.1501 8.88002 17.9401 8.88002 17.7101C8.88002 17.4501 9.09002 17.2301 9.36002 17.2301C9.39002 16.9301 9.64002 16.7001 9.95002 16.7001M9.95002 15.8301C9.42002 15.8301 8.96002 16.1101 8.70002 16.5301C8.29002 16.7601 8.02002 17.2001 8.02002 17.7001C8.02002 18.3501 8.48002 18.9001 9.10002 19.0301L9.18002 19.0501H10.71L10.79 19.0301C11.42 18.9101 11.87 18.3501 11.87 17.7001C11.87 17.2001 11.59 16.7601 11.19 16.5301C10.93 16.1101 10.47 15.8301 9.94002 15.8301H9.95002Z",
    fill: "#1A202C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M9.33986 17.5499C9.36986 17.2499 9.61986 17.0199 9.92986 17.0199C10.2399 17.0199 10.4899 17.2499 10.5199 17.5499C10.7299 17.5499 10.8999 17.6799 10.9699 17.8699C10.9899 17.8199 10.9999 17.7599 10.9999 17.6999C10.9999 17.4399 10.7899 17.2199 10.5199 17.2199C10.4899 16.9199 10.2399 16.6899 9.92986 16.6899C9.61986 16.6899 9.36986 16.9199 9.33986 17.2199C9.07986 17.2199 8.85986 17.4399 8.85986 17.6999C8.85986 17.7599 8.86986 17.8199 8.88986 17.8699C8.95986 17.6899 9.12986 17.5499 9.33986 17.5499Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M14.3601 27.57C14.2101 27.57 14.1301 27.47 14.1101 27.43C14.0801 27.39 14.0301 27.27 14.1101 27.14L20.2101 16.46H20.2601L26.3601 27.14C26.4301 27.27 26.3801 27.39 26.3601 27.43C26.3301 27.47 26.2601 27.57 26.1101 27.57H14.3601Z",
    fill: "#6B46C1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M20.2296 17.2898L25.8496 27.1398H14.5996L20.2196 17.2898M20.2196 16.0098C20.0596 16.0098 19.9096 16.0898 19.8196 16.2398L13.7196 26.9198C13.4396 27.3998 13.7896 27.9998 14.3496 27.9998H26.0896C26.6496 27.9998 26.9896 27.3998 26.7196 26.9198L20.6196 16.2398C20.5296 16.0898 20.3796 16.0098 20.2196 16.0098Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M23.6397 7.92006C23.6697 7.62006 23.9197 7.39006 24.2297 7.39006C24.5397 7.39006 24.7897 7.62006 24.8197 7.92006C25.0297 7.92006 25.1997 8.05006 25.2697 8.24006C25.2897 8.19006 25.2997 8.13006 25.2997 8.07006C25.2997 7.81006 25.0897 7.59006 24.8197 7.59006C24.7897 7.29006 24.5397 7.06006 24.2297 7.06006C23.9197 7.06006 23.6697 7.29006 23.6397 7.59006C23.3797 7.59006 23.1597 7.81006 23.1597 8.07006C23.1597 8.13006 23.1697 8.19006 23.1897 8.24006C23.2597 8.06006 23.4297 7.92006 23.6397 7.92006Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M20.2301 17.29L14.6001 27.13H15.4501L20.2301 18.76L25.0101 27.13H25.8501L20.2301 17.29Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M6.17992 27.57C6.02992 27.57 5.94992 27.47 5.92992 27.43C5.89992 27.39 5.84992 27.27 5.92992 27.14L13.7999 13.27H13.8499L21.7199 27.14C21.7899 27.27 21.7399 27.39 21.7199 27.43C21.6899 27.47 21.6199 27.57 21.4699 27.57H6.17992Z",
    fill: "#D6BCFA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M13.8199 14.0901L21.2099 27.1301H6.41986L13.8099 14.0901M13.8099 12.8101C13.6499 12.8101 13.4999 12.8901 13.4099 13.0401L5.53986 26.9101C5.26986 27.3901 5.61986 27.9901 6.16986 27.9901H21.4399C21.9899 27.9901 22.3399 27.3901 22.0699 26.9101L14.1999 13.0401C14.1099 12.8801 13.9599 12.8101 13.7999 12.8101H13.8099Z",
    fill: "#1A202C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M13.8199 14.0898L6.41992 27.1298H7.48992L13.8199 15.9698L20.1399 27.1298H21.2099L13.8199 14.0898Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    opacity: 0.4,
    d: "M15.61 9.25977H14.25V9.67977H15.61V9.25977Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    opacity: 0.4,
    d: "M17.89 10.1099H16.48V10.5299H17.61L17.6 10.5099L17.89 10.1099Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3520_8863"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChallengesCompleted);
export default __webpack_public_path__ + "static/media/ChallengesCompleted.723cc56ac82e1eddf8b587a00699b498.svg";
export { ForwardRef as ReactComponent };